<template>
  <div class="h-0 border-b border-n-strong -mx-2" />
</template>
